import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Tag} from "antd";

/**
 * Props:
 * - paymentMethod: String
 * - isTag: Boolean
 * - tagColor: String
 */

class TransactionPaymentMethod extends Component {
    shouldComponentUpdate(nextProps) {
        const {
            // parent
            paymentMethod,
        } = this.props;
        return (paymentMethod !== nextProps.paymentMethod);
    }

    render() {
        const { paymentMethod, isTag, tagColor } = this.props;

        if (isTag) {
            return (
                <Tag color={tagColor}>
                    { paymentMethod || '-' }
                </Tag>
            );
        }
        return paymentMethod || '-';
    }
}

export default connect(() => ({
}), {

})(TransactionPaymentMethod);
